module.exports = __webpack_public_path__ + "img/credit-card.cb3074b8.png";